// _see_more_post.js

if (document.getElementById("blog")) {

  (function waitForjQuery(tries) {
    tries = tries || 0;

    if (window.jQuery) {
      jQuery(function ($) {
        // --- Tu código original protegido ---

        const urlParams = new URLSearchParams(window.location.search);
        const currentFilter = urlParams.get("cat") || "";
        const currentOrder = urlParams.get("order") || "DESC";

        $("#see-more")
          .off("click")
          .on("click", function () {
            const button = $(this);
            button.data("orig-text", button.text());
            const noMoreArticles = $("#no-more-articles").val() || "No hay más artículos";
            const errorArticles  = $("#error-articles").val() || "Error al cargar";
            const loading        = $("#loading").val() || "Cargando";

            const page = button.data("page") || 1;
            const ajaxUrl = "/wp-admin/admin-ajax.php";

            $.ajax({
              url: ajaxUrl,
              method: "GET",
              data: {
                action: "load_more_posts",
                page: page,
                cat: currentFilter,
                order: currentOrder,
              },
              beforeSend: function () {
                button.html(`<p>${loading}...</p><span class="p-spinner--sm"></span>`);
              },
              success: function (response) {
                if (response && String(response).trim() !== "") {
                  $("#post-list").append(response);
                  button.data("page", page + 1);
                  button.html(button.data("orig-text"));
                } else {
                  button.text(noMoreArticles).prop("disabled", true);
                }
              },
              error: function () {
                button.text(errorArticles);
              },
            });
          });
      });
    } else if (tries < 200) {
      // Reintenta cada 100ms hasta que jQuery exista (máx ~20s)
      setTimeout(function () { waitForjQuery(tries + 1); }, 100);
    }
  })();
}
